<template>
  <div class="tw-inline-flex">
    <slot name="button">
      <button
        class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-[16px] tw-h-[16px] tw-bg-[var(--event-danger)]"
        :id="tId || tooltipId"
      >
        <tooltip-warning />
      </button>
    </slot>
    <b-tooltip show :target="tId || tooltipId" triggers="hover" custom-class="event-tooltip">
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[6px] tw-border-[3px] tw-border-[#E7E7E7] tw-font-lato tw-text-[15px] tw-bg-[var(--event-white)] tw-shadow-[0px_0px_4px_rgba(0,_0,_0,_0.1)] tw-rounded-[20px] tw-px-[16px] tw-pt-[20px] tw-pb-[22px] tw-text-[var(--event-black)]"
      >
        <slot name="tooltip">
          <div
            class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-[16px] tw-h-[16px] tw-bg-[var(--event-danger)]"
          >
            <tooltip-warning />
          </div>

          {{ tooltipText }}
        </slot>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import { nanoid } from "nanoid";
import tooltipWarning from "@/views/event-page/icons/tooltip-warning.vue";

export default {
  name: "event-tooltip",

  components: {
    tooltipWarning,
  },

  data() {
    return {
      tooltipId: this.generateId(),
    };
  },

  props: {
    tId: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: "",
    },
  },

  methods: {
    generateId() {
      return nanoid();
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip.event-tooltip {
  @apply tw-opacity-100;
  ::v-deep {
    .arrow {
      display: none;
    }
    .tooltip-inner {
      @apply tw-max-w-[184px] tw-p-0 tw-bg-transparent;
    }
  }
}
</style>
